const LangFooter = {
	"footer.footerMenu._Change_Region": ["Change Region", "Thay đổi ngôn ngữ"],
	"footer.footerMenu._English": ["English", "English"],
	"footer.footerMenu._Vietnamese": ["Tiếng Việt (VN)", "Tiếng Việt (VN)"],
	"footer._copyright": [
		"© 2018 Starbucks Corporation. All rights reserved.",
		"© 2018 Starbucks Corporation. Mọi quyền được bảo lưu.",
	],
}

export default LangFooter
